interface WithOid {
	oid: string;
}

/**
 * Builds a CSV list of OIDs from a collection, optionally
 * applying a filter.
 * @param  {Array} coll - The objects
 */
export const buildOidCsv = <T extends WithOid>(coll: T[], filter?: (obj: T) => boolean) => {
	if (typeof filter === 'function') {
		coll = coll.filter(filter);
	}
	const result = coll.map((o) => o.oid).join(',');
	return result;
};

/**
 * Builds a hash containing OID keys set to true.
 * @param {String} oidCsv A comma-separated list of OIDs
 */
export const buildHashFromOidCsv = (oidCsv: string) => {
	oidCsv = oidCsv || '';
	const oids = oidCsv.split(',');

	const result = {};
	oids.forEach((o) => {
		result[o] = true;
	});

	return result;
};

/**
 * Translates a Jade OID into a unique id, without the . character, which causes issues with ag-grid.
 * @param oid
 * @returns
 */
export const translateOidIntoId = (oid) => {
	if (typeof oid !== 'string') {
		oid += '';
	}
	return oid.replace('.', '-');
};

/**
 * Translates an id, with a hyphen, into a Jade OID, with a dot.
 * @param id
 * @returns
 */
export const translateIdIntoOid = (id) => {
	if (typeof id !== 'string') {
		id += '';
	}
	let replaced = id.replace('-', '.');

	// ID, generated to ag-grid may have a _9 (any digits) on the end to make it unique.
	replaced = replaced.replace(/^(.*?)(_(.*))?$/, '$1');
	return replaced;
};
